import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import {
  Box,
  Button,
  Checkbox,
  CircularProgress,
  FormControlLabel,
  Typography
} from '@mui/material';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { isLoadingSelector } from 'src/store/selectors/statusSelector';
import {
  submitAvalBuroForm,
  SUBMIT_AVAL_BURO_FORM
} from 'src/store/actions/avalBuroFormActions';
import transformAvalFormData from 'src/utils/constants/AvalBuroForm';
import theme from 'src/theme';
import useStyles from '../styles';

const StepFour = ({ data, onNext, onBack }) => {
  const { classes } = useStyles();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const isLoading = useSelector(isLoadingSelector([SUBMIT_AVAL_BURO_FORM.action]));
  const [accepted, setAccepted] = useState(false);

  const handleSubmit = useCallback(() => {
    dispatch(submitAvalBuroForm(transformAvalFormData(data), onNext));
  }, [dispatch, data, onNext]);

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
      <Box>
        <Typography variant="h3" sx={{ marginBottom: '16px', color: theme.palette.primary.main }}>
          {t('AVAL_BURO_FORM.STEP_FOUR.TITLE')}
        </Typography>

        <Typography variant="body1" sx={{ marginBottom: '24px', whiteSpace: 'pre-line', lineHeight: 1.7 }}>
          {t('AVAL_BURO_FORM.STEP_FOUR.CONSENT_TEXT')}
        </Typography>

        <FormControlLabel
          sx={{ alignItems: 'flex-start', marginBottom: '8px' }}
          control={
            <Checkbox
              checked={accepted}
              onChange={e => setAccepted(e.target.checked)}
              color="primary"
              sx={{ paddingTop: '2px' }}
            />
          }
          label={
            <Typography variant="body1">
              {t('AVAL_BURO_FORM.STEP_FOUR.CONSENT_CHECKBOX')}
            </Typography>
          }
        />
      </Box>

      <Box className={classes.box}>
        <Button className={classes.buttons} onClick={onBack} color="primary" variant="outlined">
          {t('COMMON.BACK')}
        </Button>
        <Button
          className={clsx(classes.buttons, classes.buttonMain)}
          onClick={handleSubmit}
          disabled={!accepted || isLoading}
          color="primary"
          variant="contained"
          startIcon={isLoading ? <CircularProgress size={18} color="inherit" /> : null}
        >
          {t('AVAL_BURO_FORM.STEP_FOUR.SUBMIT')}
        </Button>
      </Box>
    </Box>
  );
};

StepFour.propTypes = {
  data: PropTypes.object,
  onNext: PropTypes.func.isRequired,
  onBack: PropTypes.func.isRequired
};

export default StepFour;
